/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DepartmentList = {
    properties: {
        departments: {
    type: 'array',
    contains: {
        type: 'Department',
    },
    isRequired: true,
},
    },
};